import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Status from './Status';
import MenuLogin from './MenuLogin';
import logo from '../img/naonel_app.png';
import { toggleSidebarD } from './ItemEdit'; // Import toggleSidebar


function HeaderLogin({ onUpdate }) {
  const { pathname } = useLocation();

  // Robustly extract IDs from the URL
  const pathSegments = pathname.split('/').filter(Boolean);
  const projectIndex = pathSegments.indexOf('proyect');
  const epicIndex = pathSegments.indexOf('epic');
  const storyIndex = pathSegments.indexOf('story');

  const projectID = projectIndex !== -1 ? pathSegments[projectIndex + 1] : null;
  const epicID = epicIndex !== -1 ? pathSegments[epicIndex + 1] : null;
  const storyID = storyIndex !== -1 ? pathSegments[storyIndex + 1] : null;

  const [projectName, setProjectName] = useState(null);
  const [epicName, setEpicName] = useState(null);
  const [storyName, setStoryName] = useState(null);

  // Aditional data for update Story, Epic, proyect and tasks
  const [storyDescription, setStoryDescription] = useState(null);
  const [storySprint, setStorySprint] = useState(null);
  const [status, setStatus] = useState(null);  
  const [epicDescription, setEpicDescription] = useState(null);
  const [epicSprint, setEpicSprint] = useState(null);
  const [proyectDescription, setProyectDescription] = useState(null);
  const [proyectSprint, setProyectSprint] = useState(null);
  

  //Sidebar
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarClosing, setIsSidebarClosing] = useState(false);

  const [editType, setEditType] = useState(null); // Tracks whether editing a story, epic, or project
  const [editData, setEditData] = useState({}); // Stores the data to edit (e.g., name, ID)

  // Inside your component
  const navigate = useNavigate(); 

  // Function to toggle the sidebar
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // Function to toggle the sidebar and set the edit type and data
  const handleEdit = (type, data) => {
    setEditType(type);
    setEditData(data);
    setIsSidebarOpen(true);
  };


  // Prefiliear todos los campos con la información original del item

  useEffect(() => {
    const fetchProjectName = async () => {
      if (projectID) {
        try {
          const response = await fetch(`https://nstjfqisb1.execute-api.us-east-1.amazonaws.com/getItem?id=${projectID}`);
          const data = await response.json();
          setProjectName(data?.result?.[0]?.[1]?.stringValue || "Project not found");
          setProyectDescription(data?.result?.[0]?.[2]?.stringValue || "Story not found");
          setProyectSprint(data?.result?.[0]?.[5]?.stringValue || "1");
          setStatus(data?.result?.[0]?.[7]?.stringValue || "Story not found");
        } catch {
          setProjectName("Error fetching project name");
        }
      }
    };
    fetchProjectName();
  }, [projectID]);

  // Fetch epic name
  useEffect(() => {
    const fetchEpicName = async () => {
      if (epicID) {
        try {
          const response = await fetch(`https://nstjfqisb1.execute-api.us-east-1.amazonaws.com/getItem?id=${epicID}`);
          const data = await response.json();
          setEpicName(data?.result?.[0]?.[1]?.stringValue || "Epic not found");
          setEpicDescription(data?.result?.[0]?.[2]?.stringValue || "Story not found");
          setEpicSprint(data?.result?.[0]?.[5]?.stringValue || "1");
          setStatus(data?.result?.[0]?.[7]?.stringValue || "Story not found");
          
        } catch {
          setEpicName("Error fetching epic name");
        }
      }
    };
    fetchEpicName();
  }, [epicID]);

  // Fetch story name
  useEffect(() => {
    const fetchStoryName = async () => {
      if (storyID) {
        try {
          const response = await fetch(`https://nstjfqisb1.execute-api.us-east-1.amazonaws.com/getItem?id=${storyID}`);
          const data = await response.json();
          setStoryName(data?.result?.[0]?.[1]?.stringValue || "Story not found");
          setStoryDescription(data?.result?.[0]?.[2]?.stringValue || "Story not found");
          setStorySprint(data?.result?.[0]?.[5]?.stringValue || "1");
          setStatus(data?.result?.[0]?.[7]?.stringValue || "Story not found");
          

        } catch {
          setStoryName("Error fetching story name");
        }
      }
    };
    fetchStoryName();
  }, [storyID]);




  // Enviar información

 // Initialize state with the existing data
 const [formData, setFormData] = useState({
  name: editData.name || '',
  id: editData.id || '',
  description: editData.description || '',
  storySprint: editData.storySprint || '',
  status: editData.status || '',
});

// Handle input changes
const handleInputChange = (event) => {
  const { name, value } = event.target;
  setEditData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};

// Handle form submission
const handlePatch = async (event) => {
  event.preventDefault();
  //console.log('Edit Data Before Patch:', editData);

  const updatedFields = {
    id: editData.id, // Ensure the 'id' is included in the request body
    ItemName: editData.name,
    ItemDescription: editData.description,
    sprint: editData.storySprint,
    status: editData.status,
  };

  //console.log('Updated Fields:', updatedFields); // Log the updated fields to verify

  try {
    const response = await fetch(`https://nstjfqisb1.execute-api.us-east-1.amazonaws.com/items/${editData.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedFields), // Send the updated fields, including 'id'
    });

    if (!response.ok) {
      const errorDetails = await response.text();
      console.error('Error Details:', errorDetails);
      alert('Failed to update. Please check the data and try again.');
    } else {
      const updatedData = await response.json();
      setStoryName(updatedFields.ItemName || storyName);
      setEpicName(updatedFields.ItemName || epicName); // Update epicName as well
      setProjectName(updatedFields.ItemName || projectName); // Update epicName as well
      setIsSidebarOpen(false);
    }
  } catch (error) {
    console.error('Error updating data:', error);
    alert('An error occurred while updating.');
  }
};


// Function to handle the Archive action
const handleArchive = async () => {
  try {
    const confirmArchive = window.confirm(`Are you sure you want to delete "${editData.name}"?`);
    if (!confirmArchive) {
      // If the user clicks "No", exit the function
      return;
    }
    
    const updatedFields = {
      id: editData.id, // Use the current item's ID
      status: "Archive", // Set the status to "archive"
    };

    const response = await fetch(`https://nstjfqisb1.execute-api.us-east-1.amazonaws.com/items/${updatedFields.id}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updatedFields),
    });

    if (response.ok) {
      const updatedData = await response.json();
      console.log('Item archived successfully:', updatedData);

      // Optionally update the UI or state to reflect the change
      setStatus("archive");
      // Dynamically get the current URL and remove the last two segments
      const currentPath = window.location.pathname; // Get the current path
      const parentPath = currentPath.split('/').slice(0, -2).join('/'); // Remove the last two segments
      navigate(parentPath || '/proyects'); // Navigate to the parent path

    } else {
      const errorDetails = await response.text();
      console.error('Error Details:', errorDetails);
      alert('Failed to archive the item. Please try again.');
    }
  } catch (error) {
    console.error('Error archiving item:', error);
    alert('An error occurred while archiving.');
  }
};


  

  // Configuración de la Ruta
  const pageTitle = (() => {
    if (projectID && epicID && storyID) {
      return (
        <>
          <a href="/proyects" style={{ marginRight: 8, textDecoration: "underline" }}>All my projects</a>
          / <a href={`/proyect/${projectID}`}>{projectName || projectID}</a>
          / <a href={`/proyect/${projectID}/epic/${epicID}`}>{epicName || epicID}</a> 
          / <span
              onClick={() => handleEdit('story', { name: storyName, id: storyID, description: storyDescription, storySprint: storySprint, status: status })}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            >
            {storyName || storyID} / Tasks
          </span>
        </>
      );
    }
    if (projectID && epicID) {
      return (
        <>
          <a href="/proyects" style={{ marginRight: 8, textDecoration: "underline" }}>All my projects</a>
          / <a href={`/proyect/${projectID}`}>{projectName || projectID}</a>
          / <span  
              onClick={() => handleEdit('epic', { name: epicName, id: epicID, description: epicDescription, storySprint: epicSprint, status: status })}
              style={{ cursor: "pointer", textDecoration: "underline" }}>
          {epicName || epicID} / Stories
          </span>
        </>
      );
    }
    if (projectID) {
      return (
        <>
          <a href="/proyects" style={{ marginRight: 8, textDecoration: "underline" }}>All my projects</a>
          / <span  
              onClick={() => handleEdit('epic', { name: projectName, id: projectID, description: proyectDescription, storySprint: proyectSprint, status: status })}
              style={{ cursor: "pointer", textDecoration: "underline" }}>
          {projectName || projectID} / Epics
        </span>
        </>
      );
    }
    if (pathname === "/proyects") {
      return "All my projects";
    }
    return "Home";
  })();





  return (
    <header>
      <section className="logo">
        <a href="/dashboard">
          <img src={logo} alt="Description of the image" />
        </a>
        <span>{pageTitle}</span>
      </section>
      <section className="menu">
        <MenuLogin />
        <Status />
      </section>
            {/* Sidebar */}
            <div
              className={`sidebar ${isSidebarOpen ? 'active' : ''} ${isSidebarClosing ? 'closing' : ''}`}
              style={{
                position: 'fixed',
                top: 0,
                left: isSidebarOpen ? '0' : '-250px', // Slide in/out
                width: '250px',
                height: '100%',
                backgroundColor: '#f4f4f4',
                boxShadow: '2px 0 5px rgba(0, 0, 0, 0.1)',
                padding: '20px',
                transition: 'left 0.3s ease', // Smooth transition
                zIndex: 1000,
              }}
      >
        <button
          onClick={toggleSidebar}
          style={{
            position: 'absolute',
            top: '10px',
            right: '-40px',
            backgroundColor: '#f4f4f4',
            border: '1px solid #ccc',
            borderRadius: '50%',
            width: '30px',
            height: '30px',
            cursor: 'pointer',
          }}
        >
          X
        </button>
        <h2>
            {editType
              ? `Editar ${editType.charAt(0).toUpperCase() + editType.slice(1)}`
              : 'Editar'}
          </h2>

          <form onSubmit={handlePatch}>
            {editType && (
              <>
                <input name="id" type="hidden" value={editData.id || ''} />
                <input name="storySprint" type="hidden" value={editData.storySprint || ''} />
                <input name="status" type="hidden" value={editData.status || ''} />
                <label>
                  Name:
                  <input type="text" name="name" value={editData.name || ''} onChange={handleInputChange} />
                </label>
                <br />
                <label>
                  Description:
                  <textarea name="description" value={editData.description || ''} onChange={handleInputChange}></textarea>
                </label>
                <br />
              </>
            )}
            <button type="submit">Save</button>
          </form>
          <button onClick={handleArchive} className="archive-button">
            Archive
          </button>
      </div>
    
    </header>
  );
};

export default HeaderLogin;